import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "../app/loginReducer";
import userManagementReducer from "./userManagementReducer";
import toastReducer from "./toastReducer";
import appInitializeReducer from "./appInitializeReducer";
import requestReducer from "./requestReducer";

export const store = configureStore({
  reducer: {
    login: loginReducer,
    userManagement: userManagementReducer,
    toast: toastReducer,
    initialLoadData: appInitializeReducer,
    request:requestReducer
  },
});

export default store;
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
